import { render, staticRenderFns } from "./EditUserReports.vue?vue&type=template&id=0725c1c1&scoped=true&"
import script from "./EditUserReports.vue?vue&type=script&lang=js&"
export * from "./EditUserReports.vue?vue&type=script&lang=js&"
import style0 from "./EditUserReports.vue?vue&type=style&index=0&id=0725c1c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0725c1c1",
  null
  
)

export default component.exports